function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var Transaction = require('../../lib/saito/transaction')["default"];
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');

/*********************************************************************************
 GAME MODULE v.

 This is a general parent class for modules that wish to implement Game logic. It
 introduces underlying methods for creating games via email invitations, and sending
 and receiving game messages over the Saito network. The module also includes random
 number routines for dice and deck management. Thanks for the Web3 Foundation for its
 support developing code that allows games to interact with cryptocurrency tokens and
 Polkadot parachains.

 This module attempts to use peer-to-peer connections with fellow gamers where
 possible in order to avoid the delays associated with on-chain transactions. All
 games should be able to fallback to using on-chain communications however. Peer-
 to-peer connections will only be used if both players have a proxymod connection
 established.

 Developers please note that every interaction with a random dice and or processing
 of the deck requires an exchange between machines, so games that do not have more
 than one random dice roll per move and/or do not require constant dealing of cards
 from a deck are easier to implement on a blockchain than those which require
 multiple random moves per turn.

 HOW IT WORKS

 We recommend new developers check out the WORDBLOCKS game for a quick introduction
 to how to build complex games atop the Saito Game Engine. Essentially, games require
 developers to manage a "stack" of instructions which are removed one-by-one from
 the main stack, updating the state of all players in the process.

 MINOR DEBUGGING NOTE

 core functionality from being re-run -- i.e. DECKBACKUP running twice on rebroadcast
 or reload, clearing the old deck twice. What this means is that if the msg.extra
 data fields are used to communicate, they should not be expected to persist AFTER
 core functionality is called like DEAL or SHUFFLE. etc. An example of this is in the
 Twilight Struggle headline code.

 **********************************************************************************/
var ModTemplate = require('./modtemplate');

//
// CORE Game Engine file are broken across several
// classes to compartmentalize related functionality
// these are all dynamically included in the main
// game-template.
//
var GameAcknowledge = require('./gametemplate-src/gametemplate-acknowledge');
var GameAnimation = require('./gametemplate-src/gametemplate-animation');
var GameArcade = require('./gametemplate-src/gametemplate-arcade');
var GameCards = require('./gametemplate-src/gametemplate-cards');
var GameMoves = require('./gametemplate-src/gametemplate-moves');
var GamePlayers = require('./gametemplate-src/gametemplate-players');
var GameQueue = require('./gametemplate-src/gametemplate-queue');
var GameGame = require('./gametemplate-src/gametemplate-game');
var GameUI = require('./gametemplate-src/gametemplate-ui');
var GameWeb3 = require('./gametemplate-src/gametemplate-web3');
var HomePage = require('./gametemplate-src/index');
var saito = require('./../saito/saito');
var GameLog = require('./../saito/ui/game-log/game-log');
var GameHud = require('./../saito/ui/game-hud/game-hud');
var GameMenu = require('./../saito/ui/game-menu/game-menu');
var GameClock = require('./../saito/ui/game-clock/game-clock');
var SaitoOverlay = require('./../saito/ui/saito-overlay/saito-overlay');
var GameCardbox = require('./../saito/ui/game-cardbox/game-cardbox');
var GamePlayerbox = require('./../saito/ui/game-playerbox/game-playerbox');
var GameCardfan = require('./../saito/ui/game-cardfan/game-cardfan');
var GameBoardSizer = require('./../saito/ui/game-board-sizer/game-board-sizer');
var GameHexGrid = require('./../saito/ui/game-hexgrid/game-hexgrid');
var GameAcknowledgeOverlay = require('./../saito/ui/game-acknowledge-overlay/game-acknowledge-overlay');
var GameHelp = require('./../saito/ui/game-help/game-help');
var GameScoreboard = require('./../saito/ui/game-scoreboard/game-scoreboard');
var GameHammerMobile = require('./../saito/ui/game-hammer-mobile/game-hammer-mobile');
var GameRaceTrack = require('./../saito/ui/game-racetrack/game-racetrack');
var GameObserverControls = require('./../saito/ui/game-observer/game-observer');
var JSON = require('json-bigint');
var GameTemplate = /*#__PURE__*/function (_ModTemplate) {
  function GameTemplate(app) {
    var _this;
    _classCallCheck(this, GameTemplate);
    _this = _callSuper(this, GameTemplate, [app]);
    _this.name = 'Game';
    _this.game_length = 30; //Estimated number of minutes to complete a game
    _this.game = {};
    _this.moves = [];
    _this.future = [];
    _this.description = 'Peer to peer gaming on the blockchain';
    _this.endmoves = [];
    _this.commands = [];
    _this.game_state_pre_move = '';
    _this.social = {
      creator: 'Saito Team',
      twitter: '@SaitoOfficial',
      title: _this.returnName(),
      url: 'https://saito.io/arcade/',
      description: _this.description,
      image: 'https://saito.tech/wp-content/uploads/2023/11/arcade-300x300.png'
    };
    _this.recordOptions = {
      container: 'body',
      callbackAfterRecord: null,
      active: true
    };
    _this.acknowledge_text = 'acknowledge'; // text shown in ACKNOWLEDGE

    // card height-width-ratio
    _this.card_height_ratio = 1.53;
    //size of the board in pixels
    _this.boardWidth = 500; //Should be overwritten by the (board game's) full size pixel width
    _this.boardRatio = 1;
    _this.grace_window = 4;
    _this.decimal_precision = 8; /* used to round off strings representing crypto/token fractions */

    //
    // optional interface -- shouldn't really have these defaults
    //
    _this.useHUD = 0;
    _this.useCardbox = 0;
    _this.useClock = 0;
    _this.lock_interface = 0;
    _this.lock_interface_step = '';
    _this.lock_interface_tx = '';

    //
    // async deals weaken security conditions, but eliminate the need for all players to be online
    // simultaneously in order to shuffle and deal cards from the deck. instead, they shuffle the
    // deck and draw cards. this exposes information about player hands, but speeds up play of games
    // like wordblocks, etc. where security requirements can be optionally reduced
    //
    _this.async_dealing = 0;
    _this.crypto_msg = 'winner takes all';
    _this.winnable = 1; // if it is possible to win this game
    _this.loseable = 1; // if it is possible to lose this game
    _this.cooperative = 0; // if this is a cooperative game

    _this.request_no_interrupts = true;
    _this.confirm_moves = 0;
    _this.confirm_this_move = 0;
    _this.animationSpeed = 1500;
    /*
     * Our self defined animations add a marker (their div id) whenever they start and remove it when they finish
     * so we can know if animations are actively moving around the screen through animation_queue
     * Meanwhile, we may want to set up a series of animations with slight pauses between each one kicks off, so animationSequence
     * holds structure object data with the animation function and its parameters. The method runAnimationQueue will execute each animation in turn
     */
    _this.animation_queue = [];
    _this.animationSequence = [];

    //
    // game interface variables
    //
    _this["interface"] = 0; // 0 = no hud
    // 1 = graphics hud
    // 2 = text hud

    _this.relay_moves_offchain_if_possible = 1;
    _this.initialize_game_offchain_if_possible = 1;
    _this.next_move_onchain_only = 0;
    _this.hud = new GameHud(app, _this);
    _this.clock = new GameClock(app, _this);
    _this.log = new GameLog(app, _this);
    _this.cardfan = new GameCardfan(app, _this);
    _this.playerbox = new GamePlayerbox(app, _this);
    _this.cardbox = new GameCardbox(app, _this);
    _this.menu = new GameMenu(app, _this);
    _this.hammer = new GameHammerMobile(app, _this);
    _this.sizer = new GameBoardSizer(app, _this); //yes constructor
    _this.scoreboard = new GameScoreboard(app, _this);
    _this.hexgrid = new GameHexGrid(app, _this);
    _this.overlay = new SaitoOverlay(app, _this, false);
    _this.acknowledge_overlay = new GameAcknowledgeOverlay(app, _this);
    _this.observerControls = new GameObserverControls(app, _this);
    _this.racetrack = new GameRaceTrack(app, _this);
    _this.game_help = new GameHelp(app, _this);
    _this.scripts = [];
    _this.styles = ['/saito/lib/jsonTree/jsonTree.css'];
    _this.game_move_notification = null;
    _this.clock_timers = {}; //Interval reference updating countdown clock
    _this.menus = [];
    _this.minPlayers = 2;
    _this.maxPlayers = 2;
    _this.lang = 'en';
    _this.log_length = 150;
    _this.card_back = 'red_back.png';
    _this.publisher_message = '';
    _this.pending = [];
    _this.archive_connected = false;

    //
    // used to generate provably-fair dice rolls
    //
    _this.secureroll_rnums = [];
    _this.secureroll_hash = '';

    //
    // used in reshuffling
    //
    _this.old_discards = {};
    _this.old_removed = {};
    _this.old_cards = {};
    _this.old_crypt = [];
    _this.old_keys = [];
    _this.old_hand = [];
    _this.halted = 0;
    _this.gaming_active = 1; //
    // this works like halted, except at the level of
    // the game engine. when a move arrives it flips to 1
    // and when a move (rnQueue) has finished executing it
    // goes back to 0. The purpose is to prevent a second
    // move from arriving and executing while the previous
    // one is still executing.
    //
    // the difference between halted and gaming_active
    // for design purposes is that halted should be
    // used when the interface stops the game (i.e. user
    // acknowledgement is required for the game to progress
    // while gaming_active happens behind the scenes.
    //

    //
    // have we tried running our existing queue?
    //
    _this.initialize_game_run = 0;

    //
    // this is distinct from this.game.initialize_game_run
    // the reason is that BOTH are set to 1 when the game
    // is initialized. But we only nope out on initializing
    // the game if BOTH are 1. This allows us to swap in and
    // out saved games, but still init the game on reload if
    // this.game.initialize_game_run is set to 1 but it is
    // a freshly loaded browser.
    //
    //
    // instead of associating a different function with each card css we are
    // associating a single one, and changing the reference function inside
    // to get different actions executed on click. Basically we swap out the
    // changeable function before attachingCardEvents and everything just works
    //
    var temp_self = _this;
    _this.changeable_callback = function (card) {};
    _this.cardbox_callback = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(card) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(temp_self.changeable_callback !== null)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return temp_self.changeable_callback(card);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.menu_backup_callback = null;
    _this.back_button_html = "<i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>";
    _this.statistical_unit = 'game';

    // Want to handle SaitoTalk through the game menu -- not the saito-header
    _this.disable_talk = true;
    _this.enable_observer = true;
    app.connection.on('update-username-in-game', function () {
      if (_this.gameBrowserActive()) {
        _this.game.playerNames = [];
        _this.game.players.forEach(function (playerKey, i) {
          var name = _this.app.keychain.returnUsername(playerKey);
          if (name.includes('@')) {
            name = name.substring(0, name.indexOf('@'));
          }

          // this is out of date for replacing anon names...
          if (name.includes('...')) {
            name = "Player ".concat(i + 1);
          }
          _this.game.playerNames.push(name);
        });
        var _loop = function _loop(i) {
          try {
            Array.from(document.querySelectorAll(".saito-playername[data-id='".concat(_this.game.players[i], "']"))).forEach(function (add) {
              return add.innerHTML = _this.game.playerNames[i];
            });
          } catch (err) {
            console.error('GT: update-username-in-game] ERROR: ', err);
          }
        };
        for (var i = 0; i < _this.game.players.length; i++) {
          _loop(i);
        }
      }
    });
    app.connection.on('league-leaderboard-loaded', function (game, leaderboard) {
      if (_this.gameBrowserActive() && _this.name == game) {
        var default_league_data = _this.respondTo('default-league');
        _this.playerRanks = [];
        _this.game.players.forEach(function (playerKey, i) {
          var player = {
            rank: 0,
            score: default_league_data === null || default_league_data === void 0 ? void 0 : default_league_data.default_score
          };
          for (var j = 0; j < leaderboard.length; j++) {
            if (leaderboard[j].publicKey == playerKey) {
              player.rank = j + 1;
              player.score = leaderboard[j].score;
              break;
            }
          }
          _this.playerRanks.push(player);
        });
        _this.insertLeagueRankings();
      }
    });
    app.connection.on('arcade-stop-game', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(game, id, reason) {
        var current_game_id;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(_this.name === game)) {
                _context2.n = 3;
                break;
              }
              if (_this.gameBrowserActive()) {
                _context2.n = 2;
                break;
              }
              current_game_id = _this.game.id;
              _this.loadGame(id);
              _context2.n = 1;
              return _this.sendStopGameTransaction(reason);
            case 1:
              _this.loadGame(current_game_id);
              _context2.n = 3;
              break;
            case 2:
              // we have received arcade-stop-game that should not be triggered if we are IN the game... this means
              // something is sending an event that is forcing game-over...
              alert('we are bug-hunting a game-ending bug -- please report this bug to developers - 582434');
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    app.connection.on('relay-notification', function (data) {
      var mod = data.mod,
        game_id = data.game_id,
        step = data.step,
        notification = data.notification;
      if (mod == _this.name) {
        if (_this.gameBrowserActive(game_id)) {
          siteMessage(notification, 2500);
          if (step > _this.game.step.game) {
            console.warn('My game state is behind opponents!');
            setTimeout(function () {
              siteMessage('Game state out of sync, auto-fixing...', 2000);
              _this.fetchRecentMoves();
            }, 2000);
          }

          //
          // Opponent sent me notice that they entered, be kind and respond
          //
          if ((data === null || data === void 0 ? void 0 : data.code) == 'enter') {
            var _this$game, _this2;
            var _data = {
              mod: _this.name,
              game_id: (_this$game = _this.game) === null || _this$game === void 0 ? void 0 : _this$game.id,
              step: _this.game.step.game,
              notification: "".concat(_this.app.keychain.returnUsername(_this.publicKey), " is already in the game"),
              code: 'respond'
            };
            if (_this.useClock && _this.game.target == _this.game.player) {
              _data.ts = _this.game.time.last_received;
            }
            if (_this.game.player) {
              _this.app.connection.emit('relay-notify-peer', _this.game.opponents, _data);
            }
            if ((_this2 = _this) !== null && _this2 !== void 0 && _this2.room_obj) {
              _this.sendMetaMessage('CALL', _this.room_obj);
            }
          }
          if (_this.useClock && data !== null && data !== void 0 && data.ts) {
            if (_this.game.target !== _this.game.player) {
              _this.game.time.last_received = data.ts;
            }
          }
        }
      }
    });
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(GameTemplate, _ModTemplate);
  return _createClass(GameTemplate, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return _superPropGet(GameTemplate, "render", this, 3)([app]);
            case 1:
              app.connection.emit('set-relay-status-to-busy', {});
              if (!this.header) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return this.header.render();
            case 2:
              this.initializeHTML(app);
              this.game_move_notification = new Audio('/saito/sound/Belligerent.mp3');
              if (this.game.crypto) {
                this.insertCryptoLogo(this.game.crypto);
              }

              //
              // try to fetch games moves if we have finished init
              //
              if (this.game.step.game > 2) {
                this.fetchRecentMoves();
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              console.error(_t);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function render(_x5) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "returnImage",
    value: function returnImage() {
      return "/".concat(this.returnSlug(), "/img/arcade/arcade.jpg");
    }
  }, {
    key: "returnBanner",
    value: function returnBanner() {
      return "/".concat(this.returnSlug(), "/img/arcade/arcade-banner-background.png");
    }
  }, {
    key: "initializeHTML",
    value: function initializeHTML(app) {
      var _this$game2, _this$game3, _this$game3$substring, _this$game4;
      //
      // if we are trying to load a game, check
      //
      try {
        var load_id = app.browser.returnURLParameter('load');
        if (load_id) {
          for (var z = 0; z < this.app.options.games.length; z++) {
            if (this.app.options.games[z].id == load_id) {
              if (this.app.options.saves[load_id]) {
                this.app.options.games[z] = this.app.options.saves[load_id];
                this.app.options.games[z].timestamp = new Date().getTime();
                this.loadGame(load_id);
                var newUrl = this.app.browser.protocol + '://' + this.app.browser.host + '/' + this.returnSlug();
                try {
                  window.history.pushState({}, '', newUrl);
                } catch (err) {}
              }
            }
          }
        } else {
          if (this.app.options.saves) {
            for (var key in this.app.options.saves) {
              var x = new Date().getTime() - this.app.options.saves[key].timestamp;
              if (x > 50000000) {
                delete this.app.options.saves[key];
              }
            }
          }
        }
      } catch (err) {
        console.error('GT [initializeHTML] ERROR WITH LOAD:', err);
      }

      //
      // initialize game feeder tries to do this
      //
      // it needs to as the QUEUE which starts
      // executing may updateStatus and affect
      // the interface. So this is a sanity check
      //
      // These two tests should be copied to the top of any module that extends gameTemplate
      //
      if (this.browser_active == 0) {
        return;
      }
      if (this.initialize_game_run == 1) {
        return 0;
      }
      console.log('[OBS_TRACE] initializeHTML() (first run)', {
        game_player: (_this$game2 = this.game) === null || _this$game2 === void 0 ? void 0 : _this$game2.player,
        game_id: (_this$game3 = this.game) === null || _this$game3 === void 0 || (_this$game3 = _this$game3.id) === null || _this$game3 === void 0 || (_this$game3$substring = _this$game3.substring) === null || _this$game3$substring === void 0 ? void 0 : _this$game3$substring.call(_this$game3, 0, 12),
        browser_active: this.browser_active
      });

      //
      // Query server to make sure you know and remember your new friends names
      this.app.connection.emit('registry-fetch-identifiers-and-update-dom', this.game.players);

      //
      // hash reflects game id and position
      //

      try {
        var oldHash = window.location.hash;
        window.location.hash = "#";
        var game_id = this.game.id;
        //This function is stupid and confusing
        window.location.hash = app.browser.initializeHash("#gid=".concat(encodeURIComponent(game_id), "&step=").concat(this.game.step.game), oldHash, {});
      } catch (err) {
        console.error('GT [initializeHTML] ERROR WITH HASH:', err);
      }

      //
      // check options for clock
      //

      if ((_this$game4 = this.game) !== null && _this$game4 !== void 0 && (_this$game4 = _this$game4.options) !== null && _this$game4 !== void 0 && _this$game4.clock) {
        if (parseFloat(this.game.options.clock) == 0) {
          this.useClock = 0;
        } else {
          var limit = parseFloat(this.game.options.clock) * 60 * 1000;
          this.clock.clock_limit = limit;
          if (!this.game.clock.length) {
            for (var i = 0; i < this.game.players.length; i++) {
              this.game.clock.push({
                limit: limit,
                spent: 0
              });
            }
            this.saveGame(this.game.id);
          }
          this.useClock = 1;
        }
      }
      if (this.game.player == 0) {
        document.body.classList.add('observer-mode');
      }

      //
      // load initial display preferences
      //
      if (this.app.options != undefined) {
        if (this.app.options.gameprefs != undefined) {
          if (this.app.options.gameprefs.lang != undefined) {
            this.lang = this.app.options.gameprefs.lang;
          }
          if (this.app.options.gameprefs["interface"] != undefined) {
            this["interface"] = this.app.options.gameprefs["interface"];
          }
        }
      }
      this.attachStyleSheets();
    }
  }, {
    key: "gameBrowserActive",
    value: function gameBrowserActive() {
      var game_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.browser_active) {
        try {
          var vars_in_url = this.app.browser.parseHash(window.location.hash);
          if ((vars_in_url === null || vars_in_url === void 0 ? void 0 : vars_in_url.gid) == null) return false;
          game_id = vars_in_url.gid;
          try {
            game_id = decodeURIComponent(vars_in_url.gid);
          } catch (_) {}
          return game_id === this.game.id;
        } catch (err) {
          var _this$game5;
          if (((_this$game5 = this.game) === null || _this$game5 === void 0 ? void 0 : _this$game5.player) === 0) {
            console.log('[OBS_TRACE] gameBrowserActive() catch', err === null || err === void 0 ? void 0 : err.message);
          }
          return false;
        }
      }
      return false;
    }
  }, {
    key: "attachEvents",
    value: function () {
      var _attachEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app) {
        var _this$game6,
          _this3 = this;
        var _this$game$id, _this$game$id$substri, _this$game7, header, clicked, clickMe;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(this !== null && this !== void 0 && (_this$game6 = this.game) !== null && _this$game6 !== void 0 && _this$game6.id)) {
                _context4.n = 2;
                break;
              }
              console.log('[OBS_TRACE] attachEvents() calling initializeGameQueue', {
                game_id: (_this$game$id = this.game.id) === null || _this$game$id === void 0 || (_this$game$id$substri = _this$game$id.substring) === null || _this$game$id$substri === void 0 ? void 0 : _this$game$id$substri.call(_this$game$id, 0, 12),
                game_player: (_this$game7 = this.game) === null || _this$game7 === void 0 ? void 0 : _this$game7.player
              });
              _context4.n = 1;
              return this.initializeGameQueue(this.game.id);
            case 1:
              _context4.n = 6;
              break;
            case 2:
              document.documentElement.setAttribute('data-theme', 'arcade');
              header = new SaitoHeader(this.app, this);
              _context4.n = 3;
              return header.initialize(this.app);
            case 3:
              header.header_location = '/';

              //document.querySelector("body").classList.add("scrollable-page");
              if (!document.getElementById('game-loader-screen')) {
                _context4.n = 5;
                break;
              }
              _context4.n = 4;
              return header.render();
            case 4:
              setTimeout(function () {
                document.getElementById('game-loader-screen').remove();
              }, 1500);
              this.browser_active = false;
            case 5:
              this.app.connection.on('league-data-loaded', function () {
                //What would be my league id...
                var potential_league = _this3.app.crypto.hash(_this3.returnName());

                // Use League Description
                var updated_description = false;
                var league_mod = _this3.app.modules.returnFirstRespondTo('leagues-for-arcade');
                if (league_mod) {
                  var league = league_mod.returnLeague(potential_league);
                  if (league !== null && league !== void 0 && league.description && league.description !== _this3.description) {
                    if (document.querySelector('.splash-page-game-description')) {
                      document.querySelector('.splash-page-game-description').innerHTML = league.description;
                    }
                    updated_description = true;
                    if (document.querySelector('.saito-splash-optional')) {
                      document.querySelector('.saito-splash-optional').classList.remove('hidden');
                    }
                  }
                }
                if (!updated_description) {
                  if (document.querySelector('.saito-splash-image.full')) {
                    document.querySelector('.saito-splash-image.full').setAttribute('id', 'nav_about');
                  }
                }

                // Insert Leaderboard
                if (document.querySelector('.splash-page-leaderboard')) {
                  document.querySelector('.splash-page-leaderboard').innerHTML = '';
                  _this3.app.connection.emit('league-render-into', potential_league, '.splash-page-leaderboard');
                }
              });

              // Add Recent Game Activity
              this.app.connection.on('arcade-data-loaded', function () {
                if (document.querySelector('.game-activity')) {
                  document.querySelector('.game-activity').innerHTML = "<div class=\"league-overlay-games-list\"></div>";
                }
                _this3.app.connection.emit('league-overlay-games-list', {
                  game: _this3.name
                });
              });

              //Launch league overlay by default... ?
              // 1) the css is a bit trick to port in
              // 2) we need a way to initialize the game when browser_active
              //this.app.connection.emit('league-overlay-render-request', this.app.crypto.hash(this.returnName()));
              if (document.getElementById('return-to-arcade')) {
                document.getElementById('return-to-arcade').onclick = function (e) {
                  navigateWindow('/arcade');
                };
              }
              clicked = false;
              clickMe = function clickMe() {
                if (!clicked) {
                  clicked = true;
                  return;
                }
                _this3.app.connection.emit('arcade-launch-game-wizard', {
                  game: _this3.name,
                  skip: 1
                });
              };
              if (document.getElementById('create-game-button')) {
                document.getElementById('create-game-button').onclick = clickMe;
              }
              if (document.getElementById('create-game-button-mobile')) {
                document.getElementById('create-game-button-mobile').onclick = clickMe;
              }
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function attachEvents(_x6) {
        return _attachEvents.apply(this, arguments);
      }
      return attachEvents;
    }() //
    // ARCADE SUPPORT
    //
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      /*
      This is primarily used as a flag to say "Yes I am a game", but some arcade functions want to
      access the game properties to render properly
      */
      if (type == 'arcade-games') {
        if (this.sort_priority == undefined) {
          this.sort_priority = this !== null && this !== void 0 && this.status ? -1 : 0;
        }
        var x = {};
        x.image = this.returnImage();
        x.banner = this.returnBanner();
        return x;
      }
      if (type == 'default-league') {
        var _x7 = {};
        _x7.name = this.gamename || this.name;
        _x7.game = this.name;
        _x7.description = this.description;
        _x7.ranking_algorithm = 'ELO';
        _x7.default_score = 1500;
        return _x7;
      }
      return null;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, peer) {
        var service,
          _this$game8,
          _this$game9,
          data,
          tx,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              service = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              if (app.BROWSER) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (service.service == 'archive') {
                this.archive_connected = true;
              }
              if (this.gameBrowserActive()) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              if (!(service.service === 'relay')) {
                _context5.n = 4;
                break;
              }
              data = {
                mod: this.name,
                game_id: (_this$game8 = this.game) === null || _this$game8 === void 0 ? void 0 : _this$game8.id,
                step: this.game.step.game,
                notification: "".concat(this.app.keychain.returnUsername(this.publicKey), " has entered the game"),
                code: 'enter'
              };
              if (this.useClock && this.game.target == this.game.player) {
                data.ts = this.game.time.last_received;
              }
              if (this.game.player) {
                this.app.connection.emit('relay-notify-peer', this.game.opponents, data);
              }
              if (!(this.game && !((_this$game9 = this.game) !== null && _this$game9 !== void 0 && _this$game9.initializing))) {
                _context5.n = 3;
                break;
              }
              _context5.n = 3;
              return this.getPendingGameMoves();
            case 3:
              if (this.pending.length > 0) {
                console.info(' ****\nGT:  REBROADCASTING GAME MOVES\n ***');
                this.gaming_active = 0;
                while (this.pending.length > 0) {
                  tx = this.pending.shift();
                  this.app.network.propagateTransaction(tx);
                  this.app.connection.emit('relay-send-message', {
                    recipient: this.game.accepted,
                    request: 'game relay gamemove',
                    data: tx.toJson()
                  });
                }
              }
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onPeerServiceUp(_x8, _x9) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "initializeObserverMode",
    value: function () {
      var _initializeObserverMode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(tx) {
        var _game_id$substring;
        var use_state,
          game_id,
          txmsg,
          i,
          players,
          z,
          players_reconstructed,
          _z,
          zz,
          _i,
          _i2,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              use_state = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
              game_id = tx.signature;
              txmsg = tx.returnMessage();
              console.log('[OBS_TRACE] initializeObserverMode()', {
                game_id: game_id === null || game_id === void 0 || (_game_id$substring = game_id.substring) === null || _game_id$substring === void 0 ? void 0 : _game_id$substring.call(game_id, 0, 12),
                use_state: use_state
              });

              // console.log(' !!!!!\n GT: OBSERVER MODE\n !!!!!\n', game_id, JSON.parse(JSON.stringify(txmsg)));

              this.loadGame(game_id);
              this.game.player = 0;
              this.saveGame(game_id);

              //
              // otherwise setup the game
              //
              this.game.options = txmsg.options;
              this.game.module = txmsg.game;
              this.game.originator = txmsg.originator; //Keep track of who initiated the game
              this.game.players_needed = txmsg.players.length; //So arcade renders correctly

              for (i = 0; i < txmsg.players.length; i++) {
                this.addPlayer(txmsg.players[i]);
              }
              this.saveGame(game_id);
              if (this.game.players_set == 0) {
                this.gaming_active = 1; //Prevent any moves processing while sorting players
                players = [];
                for (z = 0; z < this.game.players.length; z++) {
                  players.push(this.app.crypto.hash(this.game.players[z] + this.game.id));
                }
                players.sort();
                players_reconstructed = [];
                for (_z = 0; _z < players.length; _z++) {
                  for (zz = 0; zz < this.game.players.length; zz++) {
                    if (players[_z] === this.app.crypto.hash(this.game.players[zz] + this.game.id)) {
                      players_reconstructed.push(this.game.players[zz]);
                    }
                  }
                }
                this.game.players = players_reconstructed;
                for (_i = 0; _i < this.game.players.length; _i++) {
                  // defaults to SAITO keys
                  // I guess this is useful for something...
                  this.game.keys.push(this.game.players[_i]);
                }

                //
                // game step
                //
                for (_i2 = 0; _i2 < this.game.players.length; _i2++) {
                  this.game.step.players[this.game.players[_i2]] = 0;
                }
                this.game.players_set = 1;
              }
              this.saveGame(game_id);
              if (!use_state) {
                _context6.n = 1;
                break;
              }
              this.game.live = true;
              this.saveGame(game_id);
              _context6.n = 2;
              break;
            case 1:
              _context6.n = 2;
              return this.initializeGameQueue(game_id);
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function initializeObserverMode(_x0) {
        return _initializeObserverMode.apply(this, arguments);
      }
      return initializeObserverMode;
    }()
    /*
    Called by Saito on browser load for all modules
    */
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(app) {
        var _this$game0, _this$game1;
        var params, _window$location, observerParam, vars_in_url;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.app.wallet.getPublicKey();
            case 1:
              this.publicKey = _context7.v;
              //Update social graph properties for the specific game....
              this.social.title = this.returnName();
              this.social.description = this.description;
              if (this.app.options.games == undefined) {
                this.app.options.games = [];
              }
              if (this.app.options.gameprefs == undefined) {
                this.app.options.gameprefs = {};
                this.app.options.gameprefs.random = this.app.crypto.generateKeys();
              }

              //
              // 20 second loop to rebroadcast pending txs, in case network goes down but
              // comes back up. just a safety issue.
              //
              // Todo: delete this / overkill because we already listen for network reconnect in onPeerServiceUp
              //
              /*          if (this.browser_active && this.app.BROWSER) {
                setInterval( async () => {
                              let pending = await this.app.wallet.getPendingTransactions();
                              for (let i = 0; i < pending.length; i++) {
                                      let tx = pending[i];
                                      let txmsg = tx.returnMessage();
                                      if (txmsg && txmsg.module == this.name) {
                      this.app.network.propagateTransaction(tx);
                                      }
                              }
                }, 20000);
              }
              */

              this.initializeQueueCommands(); // Define standard queue commands
              if (this.browser_active) {
                _context7.n = 2;
                break;
              }
              //
              // We need the queuecommands defined so that game invites
              // can be initialized from outside the game
              //
              this.gaming_active = 0;
              return _context7.a(2);
            case 2:
              this.calculateBoardRatio();

              //
              // we grab the game with the most current timestamp (ts)
              // since no ID is provided
              params = new URLSearchParams(window.location.search);
              if (this.loadGame()) {
                _context7.n = 4;
                break;
              }
              observerParam = params.get('observer') === '1';
              vars_in_url = typeof window !== 'undefined' && (_window$location = window.location) !== null && _window$location !== void 0 && _window$location.hash ? this.app.browser.parseHash(window.location.hash) : {};
              if (!(observerParam && vars_in_url !== null && vars_in_url !== void 0 && vars_in_url.gid)) {
                _context7.n = 3;
                break;
              }
              this.game = this.newGame(vars_in_url.gid);
              this.game.player = 0;
              this._observer_stub_bootstrap = true;
              _context7.n = 4;
              break;
            case 3:
              console.error('GT [initialize] No valid game.... stop!!!!!');
              this.initialize_game_run = 1; //Will prevent rendering of game assets
              return _context7.a(2);
            case 4:
              if (params.get('observer') === '1') {
                this.game = this.game || {};
                this.game.player = 0;
                if (this.game.id && !this._observer_stub_bootstrap) this.saveGame(this.game.id);
              }
              if (((_this$game0 = this.game) === null || _this$game0 === void 0 ? void 0 : _this$game0.player) === 0 && this.observerControls) {
                this.observerControls.initialize(this.game.id);
              }

              //
              // This function searches the wallet for txs that were sent but never received
              // We will stash them in this.pending and broadcast them as soon as we are connected to relay
              // meanwhile we won't start the game queue as normally until those bounce back to us and we process them
              //
              if ((_this$game1 = this.game) !== null && _this$game1 !== void 0 && _this$game1.initializing) {
                _context7.n = 5;
                break;
              }
              _context7.n = 5;
              return this.getPendingGameMoves();
            case 5:
              //Just make sure I am in the accepted, so if I send a message, I also receive it
              //edge case with table games/observer
              this.addFollower(this.publicKey);

              //Set navigation protection
              this.app.browser.lockNavigation(this.visibilityChange.bind(this));
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function initialize(_x1) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "initializeGame",
    value: function () {
      var _initializeGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (this.game.dice == '') {
                this.initializeDice();
                this.queue.push('READY');
                this.saveGame(this.game.id);
              }
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function initializeGame() {
        return _initializeGame.apply(this, arguments);
      }
      return initializeGame;
    }()
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(blk, tx, conf) {
        var txmsg, game_halted, game_gaming_active, game_initialize_game_run, _this$game10, game_id, current_game_id, _txmsg$step, player_publickey, player_step, _txmsg$step2, _txmsg$step3, _this$game11, asFuture, asNext;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              // console.log(
              //   'onConfirmation : ' + blk.id + '-' + blk.hash + ' conf = ' + conf + ' : ' + tx.hash
              // );
              txmsg = tx.returnMessage();
              game_halted = null;
              game_gaming_active = null;
              game_initialize_game_run = null;
              if (!(Number(conf) == 0)) {
                _context9.n = 20;
                break;
              }
              game_id = txmsg.game_id;
              if (tx.isTo(this.publicKey)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              if (this.app.BROWSER) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              if (this.doesGameExistLocally(game_id)) {
                _context9.n = 3;
                break;
              }
              return _context9.a(2);
            case 3:
              if (!this.hasSeenTransaction(tx, Number(blk.id))) {
                _context9.n = 4;
                break;
              }
              return _context9.a(2);
            case 4:
              current_game_id = null || (this === null || this === void 0 || (_this$game10 = this.game) === null || _this$game10 === void 0 ? void 0 : _this$game10.id);
              if (!current_game_id) {
                _context9.n = 7;
                break;
              }
              if (!(game_id !== current_game_id)) {
                _context9.n = 6;
                break;
              }
              //
              // sanity-check before we load, we check to see if this transaction
              // is likely to be an unprocessed move...
              //
              player_publickey = tx.from[0].publicKey;
              player_step = 0;
              if ((_txmsg$step = txmsg.step) !== null && _txmsg$step !== void 0 && _txmsg$step.game) {
                player_step = txmsg.step.game;
              }
              if (!(this.isUnprocessedMoveQuickCheck(player_publickey, player_step, game_id) == -1)) {
                _context9.n = 5;
                break;
              }
              return _context9.a(2);
            case 5:
              //
              // track execution state of game we shift away from...
              //
              game_halted = this.halted;
              game_gaming_active = this.gaming_active;
              game_initialize_game_run = this.initialize_game_run;
              this.saveGame(current_game_id);
              this.loadGame(game_id);
            case 6:
              _context9.n = 8;
              break;
            case 7:
              //
              // No current game, just load the one to process the move
              //
              this.loadGame(game_id);
            case 8:
              if (!(txmsg.request === 'gameover')) {
                _context9.n = 10;
                break;
              }
              _context9.n = 9;
              return this.receiveGameoverTransaction(blk, tx, conf, this.app);
            case 9:
              _context9.n = 19;
              break;
            case 10:
              if (!(txmsg.request === 'stopgame')) {
                _context9.n = 12;
                break;
              }
              _context9.n = 11;
              return this.receiveStopGameTransaction(tx.from[0].publicKey, txmsg);
            case 11:
              _context9.n = 19;
              break;
            case 12:
              if (!(txmsg.request === 'game')) {
                _context9.n = 18;
                break;
              }
              if (txmsg !== null && txmsg !== void 0 && (_txmsg$step2 = txmsg.step) !== null && _txmsg$step2 !== void 0 && _txmsg$step2.game) {
                _context9.n = 13;
                break;
              }
              _context9.n = 17;
              break;
            case 13:
              if (this.game.over) {
                _context9.n = 17;
                break;
              }
              //
              // process game move
              //
              asFuture = (this === null || this === void 0 ? void 0 : this.treat_all_moves_as_future) || this.isFutureMove(tx.from[0].publicKey, txmsg);
              asNext = !asFuture && this.isUnprocessedMove(tx.from[0].publicKey, txmsg);
              console.log('[OBS_TRACE] onConfirmation(game move)', {
                step: txmsg === null || txmsg === void 0 || (_txmsg$step3 = txmsg.step) === null || _txmsg$step3 === void 0 ? void 0 : _txmsg$step3.game,
                game_player: (_this$game11 = this.game) === null || _this$game11 === void 0 ? void 0 : _this$game11.player,
                asFuture: asFuture,
                asNext: asNext,
                gaming_active: this.gaming_active,
                halted: this.halted
              });

              //
              // cache recently received move
              //
              this.cacheRecentMove(tx);
              if (!asFuture) {
                _context9.n = 15;
                break;
              }
              _context9.n = 14;
              return this.addFutureMove(tx);
            case 14:
              _context9.n = 17;
              break;
            case 15:
              if (!asNext) {
                _context9.n = 17;
                break;
              }
              _context9.n = 16;
              return this.addNextMove(tx);
            case 16:
              this.notifyMove();
              _context9.n = 17;
              break;
            case 17:
              _context9.n = 19;
              break;
            case 18:
              this.receiveMetaMessage(tx);
            case 19:
              //
              // Restore game state after processing onchain transactions
              //
              if (current_game_id && current_game_id !== game_id) {
                this.loadGame(current_game_id);

                //
                // track execution state of game we shift away from...
                //
                if (game_halted != null) {
                  console.debug("GT [onConfirmation]: Did we change the game's state? ", this.halted, this.gaming_active, this.initialize_game_run);
                  this.halted = game_halted;
                  this.gaming_active = game_gaming_active;
                  this.initialize_game_run = game_initialize_game_run;
                }
                if (this.gameBrowserActive()) {
                  // We need to do something to restore the status that aren't saved in the wallet
                  // like the chess engine or worblocks dictionary
                  this.initializeGame();
                }
              }
            case 20:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function onConfirmation(_x10, _x11, _x12) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(app) {
        var _message;
        var tx,
          peer,
          mycallback,
          message,
          _message2,
          gametx,
          gametxmsg,
          newtx,
          obj,
          obj2,
          tx_json,
          _this$game12,
          recipients,
          z,
          zz,
          _newtx,
          _this$game13,
          asFuture,
          asNext,
          _gametxmsg,
          _args0 = arguments,
          _t2,
          _t3;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              tx = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
              peer = _args0.length > 2 ? _args0[2] : undefined;
              mycallback = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : null;
              if (!(tx == null)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, 0);
            case 1:
              _context0.p = 1;
              message = tx.returnMessage();
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t2 = _context0.v;
              return _context0.a(2, 0);
            case 3:
              if (!(app.BROWSER == 0)) {
                _context0.n = 4;
                break;
              }
              return _context0.a(2, 0);
            case 4:
              if (!((_message = message) !== null && _message !== void 0 && (_message = _message.request) !== null && _message !== void 0 && _message.includes('game relay'))) {
                _context0.n = 39;
                break;
              }
              if (!(((_message2 = message) === null || _message2 === void 0 ? void 0 : _message2.data) != undefined)) {
                _context0.n = 39;
                break;
              }
              gametx = new Transaction(undefined, message.data);
              gametxmsg = gametx.returnMessage(); //
              // Unlike onConfirmation, it seems every module runs handlePeerTransaction
              //
              if (!(message.request === 'game relay moves return')) {
                _context0.n = 14;
                break;
              }
              _context0.p = 5;
              _context0.n = 6;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 6:
              newtx = _context0.v;
              obj = this.app.crypto.base64ToString(message.data.buffer);
              obj2 = JSON.parse(obj);
              tx_json = obj2.tx;
              newtx.deserialize_from_web(this.app, tx_json);
              gametx = newtx;
              gametxmsg = newtx.returnMessage();
              _context0.n = 8;
              break;
            case 7:
              _context0.p = 7;
              _t3 = _context0.v;
            case 8:
              if (!(this !== null && this !== void 0 && this.treat_all_moves_as_future || this.isFutureMove(gametx.from[0].publicKey, gametxmsg))) {
                _context0.n = 10;
                break;
              }
              _context0.n = 9;
              return this.addFutureMove(gametx);
            case 9:
              _context0.n = 13;
              break;
            case 10:
              if (!this.isUnprocessedMove(gametx.from[0].publicKey, gametxmsg)) {
                _context0.n = 12;
                break;
              }
              _context0.n = 11;
              return this.addNextMove(gametx);
            case 11:
              this.notifyMove();
              _context0.n = 13;
              break;
            case 12:
              console.warn('GT HPT: is old move ' + gametxmsg.step.game);
            case 13:
              return _context0.a(2);
            case 14:
              if (!(this.name === gametxmsg.module)) {
                _context0.n = 39;
                break;
              }
              //
              // Legacy safety catch in case somewhere doesn't use game_id as the standard in the message
              //
              if (gametxmsg.id) {
                gametxmsg.game_id = gametxmsg.id;
              }
              if (this.doesGameExistLocally(gametxmsg.game_id)) {
                _context0.n = 15;
                break;
              }
              console.info("GT HPT Game does not exist locally. waiting for on-chain to process (".concat(message.request, "): "));
              return _context0.a(2);
            case 15:
              if (!(!((_this$game12 = this.game) !== null && _this$game12 !== void 0 && _this$game12.id) || gametxmsg.game_id != this.game.id)) {
                _context0.n = 16;
                break;
              }
              console.warn('GT HPT Receiving move for undefined or other game: ' + gametxmsg.game_id);
              return _context0.a(2);
            case 16:
              if (!message.request.includes('game relay')) {
                _context0.n = 17;
                break;
              }
              if (!this.hasSeenTransaction(gametx)) {
                _context0.n = 17;
                break;
              }
              return _context0.a(2);
            case 17:
              if (!(message.request === 'game relay recent moves')) {
                _context0.n = 24;
                break;
              }
              recipients = [];
              recipients.push(tx.from[0].publicKey);
              z = 0;
            case 18:
              if (!(z < this.game.recent_moves_cache.length)) {
                _context0.n = 23;
                break;
              }
              zz = 0;
            case 19:
              if (!(zz < this.game.recent_moves_cache[z].length)) {
                _context0.n = 22;
                break;
              }
              _context0.n = 20;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 20:
              _newtx = _context0.v;
              _newtx.msg = {
                request: 'game relay moves return',
                module: message.module,
                game_id: message.game_id,
                timestamp: new Date().getTime(),
                tx: this.game.recent_moves_cache[z][zz]
              };
              this.app.connection.emit('relay-send-message', {
                request: 'game relay moves return',
                recipient: recipients,
                data: _newtx.toJson()
              });
            case 21:
              zz++;
              _context0.n = 19;
              break;
            case 22:
              z++;
              _context0.n = 18;
              break;
            case 23:
              return _context0.a(2, 0);
            case 24:
              if (!(message.request === 'game relay gamemove')) {
                _context0.n = 31;
                break;
              }
              if (!this.game.over) {
                _context0.n = 25;
                break;
              }
              return _context0.a(2, 0);
            case 25:
              asFuture = (this === null || this === void 0 ? void 0 : this.treat_all_moves_as_future) || this.isFutureMove(gametx.from[0].publicKey, gametxmsg);
              asNext = !asFuture && this.isUnprocessedMove(gametx.from[0].publicKey, gametxmsg);
              if (((_this$game13 = this.game) === null || _this$game13 === void 0 ? void 0 : _this$game13.player) === 0) {
                console.log('[OBS_TRACE] handlePeerTransaction(game relay gamemove)', {
                  step: (_gametxmsg = gametxmsg) === null || _gametxmsg === void 0 || (_gametxmsg = _gametxmsg.step) === null || _gametxmsg === void 0 ? void 0 : _gametxmsg.game,
                  asFuture: asFuture,
                  asNext: asNext,
                  gaming_active: this.gaming_active,
                  halted: this.halted
                });
              }

              //
              // cache recently received move
              //
              this.cacheRecentMove(gametx);
              if (!asFuture) {
                _context0.n = 27;
                break;
              }
              _context0.n = 26;
              return this.addFutureMove(gametx);
            case 26:
              _context0.n = 30;
              break;
            case 27:
              if (!asNext) {
                _context0.n = 29;
                break;
              }
              _context0.n = 28;
              return this.addNextMove(gametx);
            case 28:
              this.notifyMove();
              _context0.n = 30;
              break;
            case 29:
              console.warn('GT HPT: is old move ' + gametxmsg.step.game);
            case 30:
              _context0.n = 38;
              break;
            case 31:
              if (!(message.request == 'game relay update')) {
                _context0.n = 37;
                break;
              }
              if (!(gametxmsg.request == 'gameover')) {
                _context0.n = 33;
                break;
              }
              _context0.n = 32;
              return this.receiveGameoverTransaction(null, gametx, 0, app);
            case 32:
              _context0.n = 36;
              break;
            case 33:
              if (!(gametxmsg.request == 'stopgame')) {
                _context0.n = 35;
                break;
              }
              _context0.n = 34;
              return this.receiveStopGameTransaction(gametx.from[0].publicKey, gametxmsg);
            case 34:
              _context0.n = 36;
              break;
            case 35:
              this.receiveMetaMessage(gametx);
            case 36:
              _context0.n = 38;
              break;
            case 37:
              console.warn('GT HPT Unknown request', message.request);
            case 38:
              return _context0.a(2, 1);
            case 39:
              return _context0.a(2, _superPropGet(GameTemplate, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee0, this, [[5, 7], [1, 2]]);
      }));
      function handlePeerTransaction(_x13) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "insertLeagueRankings",
    value: function insertLeagueRankings() {
      if (this !== null && this !== void 0 && this.insert_rankings && this.playerRanks) {
        for (var i = 0; i < this.playerRanks.length; i++) {
          var np = this.playerRanks[i].rank ? "#".concat(this.playerRanks[i].rank, " / ").concat(this.playerRanks[i].score) : "Unranked / ".concat(this.playerRanks[i].score);
          var line = "<span>".concat(np, "</span>");
          if (this.game.crypto && this.game.crypto !== 'CHIPS' && this.game.stake) {
            if (_typeof(this.game.stake) === 'object') {
              line += "<span class=\"player-stake\">".concat(this.game.stake[this.game.players[i]], " ").concat(this.game.crypto, "</span>");
            } else {
              line += "<span class=\"player-stake\">".concat(this.game.stake, " ").concat(this.game.crypto, "</span>");
            }
          }
          this.playerbox.updateUserline(line, i + 1);
        }
      }
    }
  }, {
    key: "preloadImages",
    value: function () {
      var _preloadImages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              return _context1.a(2);
          }
        }, _callee1);
      }));
      function preloadImages() {
        return _preloadImages.apply(this, arguments);
      }
      return preloadImages;
    }() //
    // Games should have a function to turn off all game-specific dom events
    //
  }, {
    key: "removeEvents",
    value: function removeEvents() {}

    //
    // Fisher–Yates shuffle algorithm:
    //
  }, {
    key: "shuffleArray",
    value: function shuffleArray(a) {
      var j, x, i;
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
      }
      return a;
    }

    //
    // OBSERVER MODE - return keystate prior to move (hand, etc.)
    //
    // JSON.parse(JSON.stringify(this.game));
    // JSON.parse(JSON.stringify(this.game_state_pre_move));
  }, {
    key: "returnGameState",
    value: function returnGameState(game_clone) {
      var sharekey = this.loadGamePreference(this.game.id + '_sharekey');
      for (var i = 0; i < game_clone.deck.length; i++) {
        if (sharekey) {
          game_clone.deck[i].hand = this.app.crypto.encodeXOR(this.app.crypto.stringToHex(JSON.stringify(game_clone.deck[i].hand)), sharekey);
          game_clone.deck[i].keys = this.app.crypto.encodeXOR(this.app.crypto.stringToHex(JSON.stringify(game_clone.deck[i].keys)), sharekey);
        } else {
          game_clone.deck[i].keys = [];
          game_clone.deck[i].hand = [];
        }
      }
      return game_clone;
    }
  }, {
    key: "startClock",
    value: function startClock() {
      var _this4 = this;
      var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.game.target;
      if (!this.useClock) {
        return;
      }
      if (this.clock_timers[player]) {
        clearInterval(this.clock_timers[player]); //Just in case
      }

      // console.debug('GT Start CLOCK: ', player, JSON.parse(JSON.stringify(this.game.clock)));

      if (!player) {
        return;
      }
      if (!this.game.time.last_received) {
        this.game.time.last_received = new Date().getTime();
      }

      //Refresh the clock every second
      this.clock_timers[player] = setInterval(function () {
        var t = new Date().getTime();
        var time_on_clock = _this4.game.clock[player - 1].limit - (t - _this4.game.time.last_received) - _this4.game.clock[player - 1].spent;
        if (time_on_clock <= 0) {
          clearInterval(_this4.clock_timers[player]);
          delete _this4.clock_timers[player];
          _this4.clock.displayTime(0, player);
          if (_this4.game.player == player) {
            _this4.game.clock[player - 1].spent = _this4.game.clock[player - 1].limit;
            _this4.onTimeOver();
            salert('Time Over!');
            return;
          }
        }
        _this4.clock.displayTime(time_on_clock, player);
      }, 1000);
    }
  }, {
    key: "stopClock",
    value: function stopClock() {
      var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.game.target;
      if (!this.useClock) {
        return;
      }
      if (!player) {
        return;
      }
      if (!this.clock_timers[player]) {
        return;
      }

      //
      // Only process if the clock is running (avoid double taps for when we send a move and receive it back on chain)
      //
      // console.debug('GT Stop CLOCK: ', player, JSON.parse(JSON.stringify(this.game.clock)));

      clearInterval(this.clock_timers[player]);
      delete this.clock_timers[player];

      //
      // game timer !!!!!!!!!!!!
      //
      this.game.time.last_sent = new Date().getTime();
      if (this.game.time.last_sent > this.game.time.last_received + 1000) {
        var _this$game$options;
        this.game.clock[player - 1].spent += this.game.time.last_sent - this.game.time.last_received;
        if ((_this$game$options = this.game.options) !== null && _this$game$options !== void 0 && _this$game$options.lightning) {
          console.log('GT Clock -- Lightning Mode!!!');
          var value = parseInt(this.game.options.lightning);
          this.game.clock[player - 1].limit += value * 1000;
        }
        var time_left = this.game.clock[player - 1].limit - this.game.clock[player - 1].spent;
        console.debug('GT TIME LEFT: ', player, time_left);
        this.clock.displayTime(time_left, player);
      }
      this.game.time.last_received = this.game.time.last_sent;
    }

    // Default is to send a game over transaction, but games
    // can override to do other things...
  }, {
    key: "onTimeOver",
    value: function onTimeOver() {
      this.sendStopGameTransaction('time out').then(function () {});
    }

    /**
     * The Game Menu calls exitGame, which allows us to be a little smarter about
     * redirecting the user back to the Saito main page (e.g. Arcade, RedSquare,
     * wherever)
     */
  }, {
    key: "exitGame",
    value: function exitGame() {
      this.app.browser.unlockNavigation();

      // Don't process game moves while exiting!
      console.info('GT: Halt game to exit');
      this.halted = 1;
      this.saveGame(this.game.id);
      this.visibilityChange();
      var homeModule = this.app.options.homeModule || 'Arcade';
      var mod = this.app.modules.returnModuleByName(homeModule);
      var slug = (mod === null || mod === void 0 ? void 0 : mod.returnSlug()) || 'arcade';
      navigateWindow("/".concat(slug), 300);
    }

    /*
    Process some non-game move messages
     (Do we need protections for game.over???)
    */
  }, {
    key: "receiveMetaMessage",
    value: function receiveMetaMessage(tx) {
      var _this5 = this;
      if (!tx.isTo(this.publicKey)) {
        console.warn("GT: processing a tx that isn't addressed to us...");
      }
      var txmsg = tx.returnMessage();
      if (txmsg.request == 'FOLLOW') {
        this.addFollower(txmsg.my_key);

        // Don't send myself an empty game state!
        if (!tx.isFrom(this.publicKey)) {
          var state = this !== null && this !== void 0 && this.cacheGame ? JSON.stringify(this.cacheGame) : '';
          this.sendMetaMessage('SHARE', state);
        }
        return;
      }
      if (txmsg.request == 'SHARE') {
        if (this.expecting_state) {
          console.info('GT [Meta] Player shared last game state', tx.from[0].publicKey);
          // console.debug(JSON.parse(JSON.stringify(this.game)));

          if ((txmsg === null || txmsg === void 0 ? void 0 : txmsg.data) != '') {
            this.game = JSON.parse(txmsg.data);
            this.game.player = 0;
            this.game.live = true;
            this.saveGame(this.game.id);
            this.app.connection.emit('arcade-game-ready-render-request', {
              name: this.name,
              slug: this.returnSlug(),
              id: this.game.id
            });

            // So we only process once!
            this.expecting_state = false;
          } else {
            this.initializeGameQueue(txmsg.game_id);
          }
        }

        // Sanity check that everyone has the right people in the accepted[]
        for (var i = 0; i < tx.to.length; i++) {
          this.addFollower(tx.to[i].publicKey);
        }
        return;
      }
      if (txmsg.request == 'CALL') {
        document.getElementById('start-group-video-chat').classList.add('notification');
        document.getElementById('start-group-video-chat').innerHTML = 'Join call';
        if (txmsg.my_key !== this.publicKey && !(this !== null && this !== void 0 && this.room_obj)) {
          document.getElementById('game-social').classList.add('notification');
          this.app.connection.emit('stun-receive-ingame-call', txmsg.data);

          // We should save this, even after hanging up...
          this.room_obj = txmsg.data;
          siteMessage("".concat(this.app.keychain.returnUsername(txmsg.my_key), " invites you to an in-game call"), 2000);
        }
      }
      if (txmsg.request == 'STAKE') {
        var auths = 0;
        var _txmsg$data = txmsg.data,
          ticker = _txmsg$data.ticker,
          stake = _txmsg$data.stake,
          sigs = _txmsg$data.sigs,
          ts = _txmsg$data.ts;
        console.info('GT STAKE: ', txmsg.data);
        try {
          var stake_val = _typeof(stake) === 'object' ? stake === null || stake === void 0 ? void 0 : stake.min : stake;
          for (var _i3 = 0; _i3 < this.game.players.length; _i3++) {
            var msg_to_verify = "".concat(ts, " ").concat(ticker, " ").concat(stake_val, " ").concat(this.game.id);
            if (sigs[_i3] !== '') {
              if (this.app.crypto.verifyMessage(msg_to_verify, sigs[_i3], this.game.players[_i3])) {
                auths++;
              }
            }
          }
        } catch (err) {
          // console.error('GT Staking ERROR: ', err);
        }
        if (auths == this.game.players.length) {
          // the game can initialize anything it needs
          this.initializeGameStake(ticker, stake);
        } else if (sigs[this.game.player - 1] == '') {
          this.app.connection.emit('accept-game-stake', {
            game_mod: this,
            ticker: ticker,
            stake: stake,
            accept_callback: function accept_callback() {
              var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              if (input != null) {
                stake[_this5.publicKey] = input;
              }
              _this5.proposeGameStake(ticker, stake, sigs, ts);
            },
            reject_callback: function reject_callback() {
              _this5.refuseGameStake(ticker, stake);
            }
          });
        }
        return;
      }

      // console.warn('GT: unprocessed meta transaction -- ', tx, txmsg);
    }

    /*
      A restricted communication format for players to exchange messages about game state that aren't moving the game forward
      FOLLOW / SHARE / STAKE / CONFIRM
      (and more in table-gametemplate)  
    */
  }, {
    key: "sendMetaMessage",
    value: function () {
      var _sendMetaMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(request) {
        var data,
          newtx,
          i,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              data = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
              _context10.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context10.v;
              newtx.msg = {
                module: this.name,
                game_id: this.game.id,
                request: request,
                my_key: this.publicKey,
                data: data
              };
              for (i = 0; i < this.game.accepted.length; i++) {
                newtx.addTo(this.game.accepted[i]);
              }

              // console.info(
              //   'GT [sendMetaMessage] to ',
              //   JSON.parse(JSON.stringify(this.game.accepted)),
              //   newtx.msg
              // );
              _context10.n = 2;
              return newtx.sign();
            case 2:
              this.app.network.propagateTransaction(newtx);
              this.app.connection.emit('relay-send-message', {
                recipient: this.game.accepted,
                request: 'game relay update',
                data: newtx.toJson()
              });
            case 3:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function sendMetaMessage(_x14) {
        return _sendMetaMessage.apply(this, arguments);
      }
      return sendMetaMessage;
    }()
  }, {
    key: "currentRound",
    value: function currentRound() {
      var _this$game14, _this$game15;
      if ((_this$game14 = this.game) !== null && _this$game14 !== void 0 && (_this$game14 = _this$game14.state) !== null && _this$game14 !== void 0 && _this$game14.round) {
        return this.game.state.round;
      } else if ((_this$game15 = this.game) !== null && _this$game15 !== void 0 && _this$game15.round) {
        return this.game.round;
      }
      return 0;
    }
  }, {
    key: "visibilityChange",
    value: function visibilityChange() {
      if (!this.game.over) {
        var _this$game16;
        var data = {
          mod: this.name,
          game_id: (_this$game16 = this.game) === null || _this$game16 === void 0 ? void 0 : _this$game16.id,
          notification: "".concat(this.app.keychain.returnUsername(this.publicKey), " has exited the game"),
          code: 'exit'
        };
        if (this.game.player) {
          this.app.connection.emit('relay-notify-peer', this.game.opponents, data);
        }
      }
    }
  }, {
    key: "returnWelcome",
    value: function returnWelcome() {
      //return `<img src="/settlers/img/welcome2.jpg"/>`;
      return null;
    }
  }, {
    key: "returnDefaultHTML",
    value: function returnDefaultHTML() {
      return "\n    <div class=\"game-loader-backdrop\" style=\"background-image: url(/".concat(this.returnSlug(), "/img/arcade/arcade.jpg);\"></div>\n    <div id=\"saito-loader-container\" class=\"saito-loader-container\"> \n          <h1>No Game Found</h1>\n          <div id=\"return-to-arcade\" class=\"button saito-button-primary\" style=\"margin-bottom:5rem;\">Go to Arcade</div>\n    </div>");
    }
  }, {
    key: "createSplashScreen",
    value: function createSplashScreen() {
      var html = "<div class=\"scrollable-page\">\n      <div class=\"saito-splash-image full\" style=\"background-image: url(/".concat(this.returnSlug(), "/img/arcade/arcade.jpg);\">\n        <div class=\"saito-splash-section-title\">\n          <h1>").concat(this.returnName(), "</h1>\n          <h3>").concat(this.categories.replace('Games ', '').split(' ').reverse().join(' '), "</h3>\n          <div class=\"saito-splash-info\">\n            <div class=\"splash-page-game-introduction\">").concat(this.description, "</div>");
      if (this.publisher_message) {
        html += "<div><em>Publisher's Note</em>: ".concat(this.publisher_message, "</div>");
      }
      html += "\n          </div>\n        </div>\n      </div>";
      html += "\n      <div class=\"saito-splash-optional hidden\">\n        <div id=\"nav_about\" class=\"saito-splash-image\" style=\"background-image: url(/".concat(this.returnSlug(), "/img/arcade/arcade-banner-background.png);\">\n          <div class=\"saito-splash-section-title\">\n            <h2>About</h2>\n          </div>\n        </div>\n        <div class=\"saito-splash-info\">\n          <div class=\"splash-page-game-description\"></div>\n        </div>\n      </div>\n      <div id=\"nav_rankings\" class=\"saito-splash-image\" style=\"background-image: url(/").concat(this.returnSlug(), "/img/arcade/arcade-banner-background.png);\">\n        <div class=\"saito-splash-section-title\">\n          <h2>Leaderboard</h2>\n        </div>\n      </div>\n      <div class=\"saito-splash-info\">\n        <div class=\"splash-page-leaderboard\">\n          <div id=\"saito-loader-container\" class=\"saito-loader-container non-blocker\"><div class=\"saito-loader\"></div></div>\n        </div>\n      </div>\n      <div id=\"nav_activity\" class=\"saito-splash-image\" style=\"background-image: url(/").concat(this.returnSlug(), "/img/arcade/arcade-banner-background.png);\">\n        <div class=\"saito-splash-section-title\">\n          <h2>Recent Activity</h2>\n        </div>\n      </div>\n      <div class=\"saito-splash-info\">\n        <div class=\"game-activity\">\n          <div id=\"saito-loader-container\" class=\"saito-loader-container non-blocker\"><div class=\"saito-loader\"></div></div>\n        </div>\n      </div>\n      <div id=\"nav_learn\" class=\"saito-splash-image\" style=\"background-image: url(/").concat(this.returnSlug(), "/img/arcade/arcade-banner-background.png);\">\n        <div class=\"saito-splash-section-title\">\n          <h2>How to Play</h2>\n        </div>\n      </div>\n      <div class=\"saito-splash-info\">\n        ").concat(this.returnGameRulesHTML(), "\n      </div>\n\n      <!-- navigation -->\n      <nav class=\"saito-splash-nav\" style=\"background-image:url(/").concat(this.returnSlug(), "/img/arcade/menu-img.gif);\">\n      <ul>\n      <li><a href=\"#nav_about\">about</a></li>\n      <li><a href=\"#nav_rankings\">rankings</a></li>\n      <li><a href=\"#nav_activity\"><button id=\"create-game-button\" class=\"saito-button-primary\">create game</button></li></a>\n      <li><a href=\"#nav_activity\">activity</a></li>\n      <li><a href=\"#nav_learn\">learn</a></li>\n      </ul>\n      </nav>\n      <a id=\"mobile-anchor\" href=\"#nav_activity\"><button id=\"create-game-button-mobile\" class=\"saito-button-secondary\"><i class=\"fa-solid fa-plus\"></i></button></a>\n      </div>\n    ");
      return html;
    }
  }, {
    key: "injectGameHTML",
    value: function () {
      var _injectGameHTML = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(template) {
        var _this$game17;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (this.game_template_injected) {
                _context11.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              this.header.header_class = 'game';
              _context11.n = 1;
              return this.timeout(500);
            case 1:
              _context11.n = 2;
              return this.header.initialize(this.app);
            case 2:
              while (document.body.hasChildNodes()) {
                document.body.firstChild.remove();
              }
              document.body.innerHTML = template;
              this.calculateBoardRatio();
              console.log('INJECT GAME HTML:' + this.game.player);
              if (((_this$game17 = this.game) === null || _this$game17 === void 0 ? void 0 : _this$game17.player) === 0 && this.observerControls) {
                console.log('and into observerControls...');
                this.observerControls.render();
              }
            case 3:
              this.game_template_injected = 1;
            case 4:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function injectGameHTML(_x15) {
        return _injectGameHTML.apply(this, arguments);
      }
      return injectGameHTML;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var mod_self = this;
      if (this.default_html) {
        expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(req, res) {
            var reqBaseURL, html;
            return _regenerator().w(function (_context12) {
              while (1) switch (_context12.n) {
                case 0:
                  reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                  mod_self.social.url = reqBaseURL + encodeURI(mod_self.returnSlug());
                  mod_self.social.image = "".concat(reqBaseURL + mod_self.returnSlug(), "/img/arcade/arcade.jpg");
                  html = HomePage(app, mod_self, app.build_number, mod_self.social);
                  if (res.finished) {
                    _context12.n = 1;
                    break;
                  }
                  res.setHeader('Content-type', 'text/html');
                  res.charset = 'UTF-8';
                  return _context12.a(2, res.send(html));
                case 1:
                  return _context12.a(2);
              }
            }, _callee12);
          }));
          return function (_x16, _x17) {
            return _ref3.apply(this, arguments);
          };
        }());
      }
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }
  }, {
    key: "returnHomePage",
    value: function returnHomePage(reqBaseURL) {
      this.social.url = reqBaseURL + encodeURI(this.returnSlug());
      this.social.image = "".concat(reqBaseURL + this.returnSlug(), "/img/arcade/arcade.jpg");
      return HomePage(this.app, this, this.app.build_number, this.social, false);
    }
  }]);
}(ModTemplate);
GameTemplate.importFunctions(GameAnimation, GameAcknowledge, GameArcade, GameCards, GameGame, GameMoves, GamePlayers, GameUI, GameQueue, GameWeb3);
module.exports = GameTemplate;